import { getDaysSince } from '../../../../lib/script'
import SimpleBoxDisplay from '../../../common/SimpleBoxDisplay'
import { useSelector } from 'react-redux'

import classes from './LienClinics.module.css'

export default function LienClinics({items}) {
    const activeCase = useSelector(state => state.case.activeCase)

    return <div className={classes.container}>
        <div className={classes.header}>
            <div>
                Counties of Record
            </div>
            <div>
                <span className={classes.fine_text}>Patient's County:</span> {activeCase?.patient?.contact_information?.county ? activeCase?.patient?.contact_information?.county : ''}
            </div>
        </div>

        <div className={classes.body}>

            {items && items.map(item => (
                <div key={item.id} className={classes.row}>
                    <SimpleBoxDisplay label={'Location'} value={item.practiceDetailed?.locations.find(elem => elem.id == item.location_id)?.code}/>{/* display_name */}
                    <SimpleBoxDisplay label={'Practice'} value={item.practiceDetailed?.locations.find(elem => elem.id == item.location_id)?.name}/>
                    <SimpleBoxDisplay label={'County'} value={item.practiceDetailed?.locations.find(elem => elem.id == item.location_id)?.contact_information?.county}/>
                    <SimpleBoxDisplay label={'Days Treating'} value={getDaysSince(item.initial_treatment)}/>
                </div>
            ))}
        </div>
    </div>
}